export default __webpack_public_path__ + "static/media/friends.7fb17741.jpeg";